// extracted by mini-css-extract-plugin
module.exports = {"block":"_13021","grow":"_13966","main":"_18263","hd":"_19892","title":"_859","close":"_6823","bd":"_15697","keyboard":"_5139"};